import { render, staticRenderFns } from "./Practitioners.vue?vue&type=template&id=135392f8&scoped=true"
import script from "./Practitioners.vue?vue&type=script&lang=js"
export * from "./Practitioners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135392f8",
  null
  
)

export default component.exports